import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from "@angular/material/dialog";
import html2canvas from 'html2canvas';
import { Toast } from '@app-utils/toast';
import { ProjectService } from '@app-services/projects.service';
@Component({
  selector: 'esg-report-modal-confirm',
  templateUrl: './esg-report-modal.component.html',
  styleUrls: ['./esg-report-modal.component.scss']
})
export class EsgReportModalComponent implements OnInit {
  projectData: any;
  projectDescription :string;
  projectName: string;
  projectId: string;
  projectImage: string;
  loading:boolean = false;
  loadingImage: boolean = false;
  @ViewChild('reportContent') reportContent: any;
  constructor(
    private projectService: ProjectService,
    public dialogRef: MatDialogRef<EsgReportModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { projectImage:string,  projectId: any, projectName: string, projectDescription:string} // Injecting Data
  ) {
    this.projectId = data.projectId;
    this.projectName = data.projectName;
    this.projectDescription = data.projectDescription;
    this.projectImage = data.projectImage;
  }

  ngOnInit() {
    this.loading = true;
    this.projectService.getProjectReport(this.projectId).subscribe(

      (response) => {
        this.loading = false
        this.projectData = response;

      },
      error => {
      if(error.error.status === 'NOT_FOUND') {
        Toast.showError({message: 'Preencha os dados do projeto antes de gerar o atestado ESG.'});
        this.loading = false;
        this.dialogRef.close(false);
        return;
      }
        Toast.showError({message: 'Erro ao carregar os dados do projeto. Tente novamente.'});
        console.error('Error fetching project report:', error);
        this.loading = false
        this.dialogRef.close(false);
      }
    );
   
  }


  downloadReport() {
    this.loadingImage = true;
    const element = this.cloneReportElement();

   

    html2canvas(element, {useCORS: true,logging: true, allowTaint: true}).then(canvas => {
      const link = document.createElement('a');
      link.download = this.projectName + '-esg-report.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
      element.remove();
      this.loadingImage = false;
      Toast.showSuccess({message: 'Atestado ESG gerado com sucesso!'});
    }).catch(error => {
 
     Toast.showError({message: 'Erro ao gerar o atestado ESG. Tente novamente.'});
     console.error('Error generating ESG report:', error);
     element?.remove();
      this.loadingImage = false;
      this.dialogRef.close(false);
    });
  }

  cloneReportElement(): HTMLElement {
    const clonedElement = this.reportContent.nativeElement.cloneNode(true);
    clonedElement.style.width = '1080px';
    clonedElement.style.height = '1920px';
    clonedElement.style.position = 'absolute';
    clonedElement.style.left = '-9999px'; // Hide off-screen
    clonedElement.style.fontSize = '48px';
    document.body.appendChild(clonedElement);

    return clonedElement;
  }

   get currentYear(): number {
    return new Date().getFullYear();
  }



  closeModal(): void {
    this.dialogRef.close(false);
  }

}
